import {IconProps} from './types';

const DotsHorizontal = ({fill = 'currentColor', className, width = 20, height = 20}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        aria-hidden
    >
        <circle cx="5" cy="12" r="2" fill={fill} />
        <circle cx="12" cy="12" r="2" fill={fill} />
        <circle cx="19" cy="12" r="2" fill={fill} />
    </svg>
);

export default DotsHorizontal;
